var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.homeSelectors,"label":"home"},model:{value:(_vm.home),callback:function ($$v) {_vm.home=$$v},expression:"home"}})
}
var staticRenderFns = []

export { render, staticRenderFns }